// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rIgSSEHGaGWPA3 {
  margin: var(--ds-space-0, 0) -12px;
  padding: var(--ds-space-400, 32px);
  background-color: var(--ds-surface-sunken, #f7f8f9);
}
.WqoZ2G6_IZwV1C {
  display: flex;
  justify-content: space-between;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"labelPreview": `rIgSSEHGaGWPA3`,
	"footer": `WqoZ2G6_IZwV1C`
};
export default ___CSS_LOADER_EXPORT___;
